import { useCallback } from "react";
import { useEffect, useState } from "react";
import {
  getAllCustomerPartnerInfra,
  getAllPartners,
  getAllRegistrationPartnerInfra,
  getPartnerById,
  presetsAllPartners,
  presetsOLTPartner,
} from "../../api/projects";
import { reportCustomerActivations } from "../../api/customer";

export function usePartnerListHooks() {
  const [partners, setPartners] = useState([]);
  const [meta, setMeta] = useState({ count: 0, page: 1, page_size: 10 });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getPartners = useCallback(async (filter = {}) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await getAllPartners({ ...filter });
      setPartners(data.data);
      setMeta(data.pagination);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  }, []);

  return {
    partners,
    meta,
    loading,
    errorMsg,
    getPartners,
  };
}

export function usePartnerHooks({ id }) {
  let [data, setData] = useState({});
  let [success, setSuccess] = useState(null);
  let [fetched, setFetched] = useState(false);
  let [error, setError] = useState(null);
  let [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      getVendor(id);
    }
  }, [id]);

  const getVendor = async (id) => {
    setData({});
    setError("");
    setLoading(true);
    setSuccess(null);
    setFetched(false);
    try {
      let response = await getPartnerById(id);
      setData(response.data.data);
      setFetched(true);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setError(data.message);
      } else {
        setError("Something Error Happened");
      }
    }

    setLoading(false);
  };

  return {
    data,
    fetched,
    success,
    error,
    loading,
    getVendor,
  };
}

export function useAllPartnersHooks() {
  const [partners, setPartners] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getAllPartners = async () => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await presetsAllPartners();
      setPartners(data.data);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getAllPartners();
  }, []);

  return {
    partners,
    loading,
    errorMsg,
    getAllPartners,
  };
}

export function useCustomersPartnerInfraHooks({ filter }) {
  const [customers, setCustomers] = useState([]);
  const [meta, setMeta] = useState({ page: 1, page_size: 10, count: 0 });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getAllCustomers = async (filter = {}) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await getAllCustomerPartnerInfra(filter);
      setCustomers(data.data);
      setMeta(data.pagination);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    if (filter) {
      getAllCustomers(filter);
    }
  }, [filter]);

  return {
    customers,
    meta,
    loading,
    errorMsg,
    getAllCustomers,
  };
}

export function useOltPartnerHooks() {
  const [oltPartners, setOltPartners] = useState([]);
  const [meta, setMeta] = useState({ count: 0, page: 1, page_size: 10 });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getOltPartners = useCallback(async () => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await presetsOLTPartner();
      setOltPartners(data.data);
      setMeta(data.pagination);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    getOltPartners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    oltPartners,
    meta,
    loading,
    errorMsg,
    getOltPartners,
  };
}

export function useRegistrationPartnerInfraHooks({ filter }) {
  const [registrations, setRegistrations] = useState([]);
  const [meta, setMeta] = useState({ page: 1, page_size: 10, count: 0 });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getAllRegistrations = async (filter = {}) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await getAllRegistrationPartnerInfra(filter);
      setRegistrations(data.data);
      setMeta(data.pagination);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    if (filter) {
      getAllRegistrations(filter);
    }
  }, [filter]);

  return {
    registrations,
    meta,
    loading,
    errorMsg,
    getAllRegistrations,
  };
}
